import { useEffect, useState } from "react"
import { Area, AreaOnScenario } from "db"
import { useMutation, invalidateQuery } from "@blitzjs/rpc"
import renameAreaOnScenario from "app/area-on-scenarios/mutations/renameAreaOnScenario"
import CompactForm from "app/core/components/CompactForm"
import getAreaOnScenario from "app/area-on-scenarios/queries/getAreaOnScenario"
import { Field } from "formik"
import { Pencil1Icon } from "@radix-ui/react-icons"
import { RenameAreaOnScenario } from "app/validations"

export function EditableAreaOnScenarioName(props: {
  areaOnScenario: AreaOnScenario | null
  area: Area
}) {
  const { areaOnScenario, area } = props
  const [renaming, setRenaming] = useState<boolean>(false)
  const [renameAreaOnScenarioMutation] = useMutation(renameAreaOnScenario)

  function formatName(areaOnScenario: AreaOnScenario | null, area: Area): string {
    let name = ""
    if (areaOnScenario && areaOnScenario.name) name += areaOnScenario.name
    else if (area.type === "PARCEL") name += "Parcel"
    else if (area.type === "RIGHT_OF_WAY") name += "Right-of-way"
    return name
  }

  useEffect(() => {
    setRenaming(false)
  }, [areaOnScenario])

  if (renaming && areaOnScenario) {
    return (
      <div className="p-3">
        <CompactForm
          initialValues={{
            name: areaOnScenario.name,
            scenarioId: areaOnScenario.scenarioId,
            areaId: areaOnScenario.areaId,
          }}
          schema={RenameAreaOnScenario}
          submitText="Rename parcel/right-of-way"
          onSubmit={async (values) => {
            await renameAreaOnScenarioMutation({
              scenarioId: areaOnScenario.scenarioId,
              areaId: areaOnScenario.areaId,
              name: values.name,
            })
            await invalidateQuery(getAreaOnScenario, {
              scenarioId: areaOnScenario.scenarioId,
              areaId: areaOnScenario.areaId,
            })
            setRenaming(false)
          }}
        >
          <Field
            type="text"
            className="h-8 flex-auto rounded-md rounded-r-none border border-r-0 border-gray-300 bg-gray-50 px-2 py-0.5 font-medium text-brand-green-dark"
            name="name"
            defaultValue={formatName(areaOnScenario, area)}
          />
        </CompactForm>
      </div>
    )
  }

  return (
    <div className="flex flex-wrap items-center gap-x-2 text-brand-green">
      <div className="font-medium capitalize">{formatName(areaOnScenario, area)}</div>
      {areaOnScenario && (
        <button
          className="text-black opacity-30 transition-opacity hover:opacity-100"
          onClick={() => setRenaming(true)}
        >
          <Pencil1Icon />
        </button>
      )}
      {area.address ? <span>| {area.address}</span> : <></>}
    </div>
  )
}
